import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import moment from "moment";
import { NotificationManager } from "react-notifications";

import { getTestimonials, deleteTestimonial, resetField } from "../../store/actions";
import { objToQueryString, queryStringToJSON } from "../../utils/common";
import PaginatedTable from "../../sharedComponents/tableWithPagination";
import NoTestimonialImage from "../../assets/images/no-recipes-found.png";
import AddTestimonial from "./add/addTestimonialPanel";
import ConfirmDelete from "../../sharedComponents/confirmDelete";
import "./Testimonials.scss";

const TestimonialListing = ({ getTestimonials, testimonialList, isAdmin, history, user, deleteTestimonial }) => {
	const [testimonials, setTestimonials] = useState([]);
	const [loading, setLoading] = useState(true);
	const [toggleAddTestimonial, setToggleAddTestimonial] = useState(false);

	const [filters, setFilters] = useState({
		limit: 10,
		member: !isAdmin ? user && user.user && user.user.id : ""
	});
	const [query, setQuery] = useState();

	useEffect(() => {
		setQuery(objToQueryString(filters));
	}, [filters]);

	useEffect(() => {
		if (query) {
			setTestimonials([]);
			setLoading(true);
			getTestimonials(`?${query}`);
		}
	}, [query, getTestimonials]);

	useEffect(() => {
		setTestimonials(() => {
			if (
				testimonialList &&
				testimonialList.results !== null &&
				testimonialList.results &&
				testimonialList.results.length === 0
			) {
				setLoading(false);
			}
			return testimonialList && testimonialList.results ? testimonialList.results : [];
		});
	}, [testimonialList]);

	const testimonialDetails = (values) => {
		history.push(`/testimonials/${values.id}/edit`);
	};

	const [selectedItem, setSelectedItem] = useState(null);
	const confirmDelete = (original) => {
		setSelectedItem(original);
	};
	const confirmEvent = (yes) => {
		if (yes) {
			const successHandler = () => {
				NotificationManager.success("Item has been removed!", "", 5000);
				getTestimonials(`?${query}`);
			};
			deleteTestimonial && deleteTestimonial(selectedItem.id, successHandler);
		}
		setSelectedItem(null);
	};

	const actionColumn = isAdmin
		? [
				{
					Header: "Assigned",
					accessor: "member",
					Cell: ({ value }) => <span>{value.email}</span>
				},
				{
					Header: "Action",
					accessor: "id",
					Cell: ({ original }) => (
						<div>
							<button
								type="button"
								onClick={() => testimonialDetails(original)}
								className="btn btn-success btn-ghost btn-sm btn-cell mr-2">
								<i className="icon icon-edit" />
							</button>
							<button
								type="button"
								onClick={() => confirmDelete(original)}
								className="btn btn-danger btn-ghost btn-sm btn-cell">
								<i className="icon icon-trash" />
							</button>
						</div>
					),
					headerClassName: "text-right",
					className: "text-right",
					sortable: false,
					width: 100
				}
		  ]
		: [];

	const columns = [
		{
			Header: "Member",
			accessor: "member",
			Cell: ({ value, original }) => (
				<span
					className={isAdmin ? "pointer text-primary-dark" : ""}
					onClick={isAdmin ? () => testimonialDetails(original) : null}>
					{value.first_name} {value.middle_name} {value.last_name}
				</span>
			),
			width: 250
		},
		{
			Header: "Notes",
			accessor: "fulltext",
			Cell: ({ original }) => <span className={isAdmin ? "text-nowrap" : "text-normal"}>{original.fulltext}</span>
		},
		{
			Header: "Clinic",
			accessor: "member",
			Cell: ({ value }) => <span>{value.clinic && value.clinic.name ? value.clinic.name : "- "}</span>
		},
		{
			Header: "Submitted",
			accessor: "created",
			Cell: ({ value }) => <span>{moment(value).format("LL")}</span>,
			width: 200
		},

		...actionColumn
	];

	return (
		<section className="page page-testimonial-listing">
			<div className="container">
				<div className="d-flex flex-row justify-content-between">
					<h3 className="flex-fill m-0">Testimonials</h3>
					<button className="btn btn-primary text-uppercase" onClick={() => setToggleAddTestimonial(true)}>
						<i className="icon icon-comment "></i> Add New
					</button>
				</div>

				<div className="table-container">
					{testimonials && testimonials.length ? (
						<PaginatedTable
							data={testimonials}
							columns={columns}
							pageSize={filters.limit}
							totalItems={testimonialList.count}
							prev={testimonialList.previous}
							next={testimonialList.next}
							onPagination={(event) => setFilters({ ...filters, ...queryStringToJSON(`?${event}`) })}
						/>
					) : null}
					{!loading && testimonials.length === 0 ? (
						<div className="alert alert-info text-center w-100 my-3 no-comments-found">
							<img src={NoTestimonialImage} alt="No comments found" />
							<div>No testimonials found!</div>
						</div>
					) : null}
				</div>
				<AddTestimonial
					toggleAddTestimonial={toggleAddTestimonial}
					setToggleAddTestimonial={setToggleAddTestimonial}
					onAdd={() => getTestimonials(`?${query}`)}
				/>
			</div>
			<ConfirmDelete item={selectedItem} message={<div>Are you sure you want to delete?</div>} onEvent={confirmEvent} />
		</section>
	);
};

const mapStateToProps = (state) => {
	const { Testimonials, Auth } = state;
	return {
		testimonialList: get(Testimonials, "testimonialsResult", {}),
		isAdmin: Auth.isAdmin,
		user: Auth.userDetails
	};
};

const mapDispatchToProps = {
	getTestimonials,
	deleteTestimonial,
	resetField
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TestimonialListing);
